// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import { Image, Pressable } from 'react-native';

import { Text, View } from '@/components/Themed';
import { t } from '@/i18n';
import { MysteryPrizeIcon } from '@/features/hole/assets';
import { styles } from '@/features/hole/screen/styles';

type HoleHeaderCardProps = {
  holeNumber: number;
  showLeaderboardLabel: boolean;
  hasMysteryPrizeForHole: boolean;
  mysteryPrizeText: string;
  onOpenMystery: () => void;
  showMysteryPrizeButton: boolean;
  onOpenMysteryPrizeSetup: () => void;
  holeName?: string;
  holeDescription?: string;
  showHoleDetails: boolean;
  onToggleDetails: () => void;
};

export function HoleHeaderCard({
  holeNumber,
  showLeaderboardLabel,
  hasMysteryPrizeForHole,
  mysteryPrizeText,
  onOpenMystery,
  showMysteryPrizeButton,
  onOpenMysteryPrizeSetup,
  holeName,
  holeDescription,
  showHoleDetails,
  onToggleDetails,
}: HoleHeaderCardProps) {
  return (
    <View style={styles.holeInfoBlock}>
      {showLeaderboardLabel ? (
        <View style={styles.titleRow}>
          <View style={styles.holeInfoRow}>
            <Text style={styles.holeInfoBadge}>{t('hole.leaderboardShortTitle')}</Text>
          </View>
        </View>
      ) : null}
      {hasMysteryPrizeForHole ? (
        <Pressable style={styles.mysteryPrizeRow} onPress={onOpenMystery}>
          <Image source={MysteryPrizeIcon} style={styles.mysteryPrizeIcon} resizeMode="contain" />
          <Text style={styles.mysteryPrizeText}>{mysteryPrizeText}</Text>
        </Pressable>
      ) : null}
      {showMysteryPrizeButton ? (
        <Pressable
          style={styles.mysteryPrizeSetupButton}
          onPress={onOpenMysteryPrizeSetup}
          accessibilityRole="button"
          accessibilityLabel={t('hole.mysteryPrizeSetup')}
        >
          <Image source={MysteryPrizeIcon} style={styles.mysteryPrizeIcon} resizeMode="contain" />
          <Text style={styles.mysteryPrizeSetupButtonText}>{t('hole.mysteryPrizeSetup')}</Text>
        </Pressable>
      ) : null}
      {holeName ? <Text style={styles.holeInfoName}>{holeName}</Text> : null}
      {holeDescription ? (
        <>
          {showHoleDetails ? <Text style={styles.holeInfoDescription}>{holeDescription}</Text> : null}
          <Pressable style={styles.detailsToggle} onPress={onToggleDetails}>
            <Text style={styles.detailsToggleText}>
              {showHoleDetails ? t('hole.hideDetails') : t('hole.showDetails')}
            </Text>
          </Pressable>
        </>
      ) : null}
    </View>
  );
}
